//@ts-check
import { Box, Grid } from "@chakra-ui/layout";
import React, { useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import Models from "./Models";
// React.createContext accepts a defaultValue as the first param
export const Context = React.createContext({ searchText: "" });

const ProductPage = ({ children }) => {
  const violationRef = useRef(null);
  useEffect(() => {
    window.scrollTo({
      top: violationRef.current.offsetTop,
      behavior: "smooth",
    });
  }, []);
  return (
    <Box px={{ md: "7", base: "3" }} py={{ md: "7", base: "3" }}>
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <Models></Models>
      <Box ref={violationRef} h="6"></Box>
      <Grid
        templateColumns="repeat(auto-fill, minmax(240px, 1fr))"
        gap={3}
        p="5"
        bg="white"
        borderWidth="thin"
        borderColor="gray.100"
        borderRadius="md"
      >
        {children}
      </Grid>
    </Box>
  );
};

export default ProductPage;
